import { mxgraphFactory } from "mxgraph-factory";

// mxGraph gets loaded from here
export const mxClient = mxgraphFactory({
    mxBasePath: window.origin + "/assets/mxgraph",
    mxLoadResources: true,
    mxLoadStylesheets: true,
    mxLanguage: "en",
});
